

import React, { createRef, CSSProperties, useEffect, useRef, useState } from 'react'
import { ChromePicker, ColorResult, SketchPicker } from 'react-color'
import "./color-picker.css"

export interface LmColorPickerProps {
    value: string;
    onChange: (target: HTMLDivElement, color: string) => void;
    open?: boolean;
    id?: string;
    title?: string;
    className?: string;
    style?: CSSProperties;
}

export default function FbxColorPicker(props: LmColorPickerProps) {
    const [_value, setValue] = useState<string>(props.value ?? 'e0e036')
    const [_open, setOpen] = useState<boolean>(props.open ?? false)
    const _ref = useRef<HTMLDivElement>(null)
    const [_clientX, setClientX] = useState<number>(0)

    useEffect(() => {
        setOpen(props.open ?? false)
    }, [props.open])

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    const handleChange = (colorResult: ColorResult, e: React.ChangeEvent<HTMLInputElement>) => {
        let value = colorResult.hex;
        if (colorResult.hex.startsWith("#"))
            value = value.substring(1);
        setValue(value)
        if (props.onChange) {
            const parent = e.target.closest(".color-picker") as HTMLDivElement;
            if (parent)
                props.onChange(parent, value)
        }
    };

    const colorStyle: React.CSSProperties = {
        width: 150,
        height: 25,
        borderRadius: '2px',
        backgroundColor: `#${_value}`,
        border: "1px solid gray"
    }

    const handleClick = (e: any) => {
        if (_ref.current) {
            let rec = _ref.current.getClientRects() //Top of the client rectangle relevant to the container.
            let offset = _ref.current.offsetParent ? (_ref.current.offsetParent as HTMLDivElement).offsetTop : 50 // the scroll offset
            let height = _ref.current.clientHeight; //The items height.
            setClientX(rec[0].top - offset + height)
        }

        setOpen(true);
    }

    return (
        <div ref={_ref} id={props.id} style={props.style} className={`color-picker ${props.className ?? ''}`}  >
            {props.title ?
                <div style={{marginBottom: 5}}><label>{props.title}</label></div> : undefined
            }
            <div className="swatch" onClick={handleClick}>
                <div style={colorStyle} />

            </div>
            {_open ? <div className="popover" style={{ top: _clientX }}>
                <div className="cover" onClick={() => setOpen(false)} />
                <SketchPicker color={_value} onChange={handleChange} />
            </div> : null}

        </div>
    )
}


